module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 009.b13fcff9.jpg";